
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    LazyImg
  }
})
export default class ArticleShareLCard extends Vue {
  @Prop() data: {
    id: number
    jumpUrl: string
    intro: string
    originalUrl: string
    picBigUrl: string
    publishTime: number
    title: string
  }

  handleClick(url: string) {
    window.open(url)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
